import React, { useEffect, useState } from 'react';
import { getLocalites, getPartenaires } from '../services/api';

const LocalitesList: React.FC = () => {
  const [localites, setLocalites] = useState<any[]>([]);
  const [partenaires, setPartenaires] = useState<any[]>([]);
  const [total, setTotal] = useState(0);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [filters, setFilters] = useState<any>({});

  useEffect(() => { getPartenaires().then(r => setPartenaires(r.data)); }, []);

  useEffect(() => {
    const params: Record<string, string> = { page: page.toString(), limit: '30' };
    Object.entries(filters).forEach(([k, v]) => { if (v) params[k] = v as string; });
    getLocalites(params).then(r => {
      if (r.data.data) {
        setLocalites(r.data.data);
        setTotal(r.data.total || 0);
        setTotalPages(r.data.totalPages || 1);
      } else {
        setLocalites(r.data);
        setTotal(r.data.length);
        setTotalPages(1);
      }
    }).catch(() => {});
  }, [page, filters]);

  return (
    <div>
      <h2 style={{ marginBottom: 20, color: '#333' }}>Localites ({total.toLocaleString('fr-FR')})</h2>

      <div className="filters-bar">
        <select value={filters.partenaire_id || ''} onChange={e => { setFilters({ ...filters, partenaire_id: e.target.value }); setPage(1); }}>
          <option value="">Tous les partenaires</option>
          {partenaires.map(p => <option key={p.id} value={p.id}>{p.libelle}</option>)}
        </select>
      </div>

      <div className="data-table-wrapper">
        <table className="data-table">
          <thead>
            <tr>
              <th>Libelle</th>
              <th>Partenaire</th>
            </tr>
          </thead>
          <tbody>
            {localites.map((l: any, i: number) => (
              <tr key={l.id || i}>
                <td><strong>{l.libelle}</strong></td>
                <td>{l.partenaire || '-'}</td>
              </tr>
            ))}
            {localites.length === 0 && (
              <tr><td colSpan={2} style={{ textAlign: 'center', padding: 40, color: '#999' }}>Aucune localite trouvee</td></tr>
            )}
          </tbody>
        </table>
      </div>

      <div className="pagination">
        <button disabled={page <= 1} onClick={() => setPage(page - 1)}>Precedent</button>
        <span style={{ padding: '8px 14px', fontSize: 14 }}>Page {page} / {totalPages}</span>
        <button disabled={page >= totalPages} onClick={() => setPage(page + 1)}>Suivant</button>
      </div>
    </div>
  );
};

export default LocalitesList;
